(() => {
  const SUCCESS_MS = 3000;
  const SUCCESS_COLOR = "#16a34a";

  const pad2 = (n) => String(Math.max(0, n)).padStart(2, "0");

  const copyCoupon = (button, textEl) => {
    const coupon = (
      button?.dataset?.couponCode ||
      textEl?.dataset?.couponCode ||
      textEl?.textContent ||
      ""
    ).trim();
    if (!coupon || !textEl) return;

    const originalText = textEl.dataset.originalText || coupon;
    const originalBtnBg = button?.style?.backgroundColor || "";

    const showSuccess = () => {
      textEl.textContent = "Copied!";
      textEl.style.color = SUCCESS_COLOR;
      if (button) button.style.backgroundColor = SUCCESS_COLOR;

      setTimeout(() => {
        textEl.textContent = originalText;
        textEl.style.color = "";
        if (button) button.style.backgroundColor = originalBtnBg;
      }, SUCCESS_MS);
    };

    const fallbackCopy = () => {
      const textarea = document.createElement("textarea");
      textarea.value = coupon;
      textarea.style.position = "fixed";
      textarea.style.opacity = "0";
      document.body.appendChild(textarea);
      textarea.select();
      textarea.setSelectionRange(0, 99999);
      try {
        const ok = document.execCommand("copy");
        if (ok) showSuccess();
      } catch (err) {
        console.error("Fallback copy failed:", err);
      } finally {
        document.body.removeChild(textarea);
      }
    };

    if (navigator.clipboard?.writeText) {
      navigator.clipboard
        .writeText(coupon)
        .then(showSuccess)
        .catch((err) => {
          console.error("Clipboard API failed:", err);
          fallbackCopy();
        });
    } else {
      fallbackCopy();
    }
  };

  const bindLegacyCoupons = (root = document) => {
    root.querySelectorAll("[data-coupon-btn]").forEach((btn) => {
      const textEl = btn
        .closest("._1_pp_dropdown")
        ?.querySelector("[data-coupon-text]");
      if (!textEl || btn.__couponBound) return;
      btn.__couponBound = true;
      btn.addEventListener("click", () => copyCoupon(btn, textEl));
    });
  };

  const bindTicketCoupons = (root = document) => {
    root.querySelectorAll("[data-coupon-ticket-btn]").forEach((btn) => {
      if (btn.__couponBound) return;
      const ticket = btn.closest(".product-coupon-ticket");
      const textEl = ticket?.querySelector("[data-coupon-ticket-text]");
      if (!textEl) return;
      btn.__couponBound = true;
      btn.addEventListener("click", (event) => {
        event.preventDefault();
        copyCoupon(btn, textEl);
      });
    });
  };

  const parseEndTime = (raw) => {
    if (!raw) return null;
    const normalized = String(raw).trim().replace(" ", "T");
    const date = new Date(normalized);
    if (Number.isNaN(date.getTime())) return null;
    return date.getTime();
  };

  const updateCountdown = (el) => {
    const endAt = parseEndTime(el.dataset.endTime);
    if (!endAt) return;

    const now = Date.now();
    let diff = Math.max(0, Math.floor((endAt - now) / 1000));

    const days = Math.floor(diff / 86400);
    diff %= 86400;
    const hours = Math.floor(diff / 3600);
    diff %= 3600;
    const minutes = Math.floor(diff / 60);
    const seconds = diff % 60;

    const daysEl = el.querySelector('[data-unit="days"]');
    const hoursEl = el.querySelector('[data-unit="hours"]');
    const minutesEl = el.querySelector('[data-unit="minutes"]');
    const secondsEl = el.querySelector('[data-unit="seconds"]');

    if (daysEl) daysEl.textContent = pad2(days);
    if (hoursEl) hoursEl.textContent = pad2(hours);
    if (minutesEl) minutesEl.textContent = pad2(minutes);
    if (secondsEl) secondsEl.textContent = pad2(seconds);
  };

  const bindCountdowns = (root = document) => {
    root.querySelectorAll("[data-coupon-countdown]").forEach((el) => {
      if (el.__countdownBound) return;
      el.__countdownBound = true;
      updateCountdown(el);
      window.setInterval(() => updateCountdown(el), 1000);
    });
  };

  const init = (root = document) => {
    bindLegacyCoupons(root);
    bindTicketCoupons(root);
    bindCountdowns(root);
  };

  document.addEventListener("DOMContentLoaded", () => init(document));
  document.addEventListener("shopify:section:load", (event) =>
    init(event.target)
  );
})();
